import React from 'react';
import {BuildCheckboxOptions} from '../../util/BuildOptions';
import MessageDefinitions from "../../i18n/MessageDefinitions";
import {FormattedMessage} from "react-intl";

const CheckboxQuestion = ({rowKey, questionKey, answers = [], valueChanged, answer}) => {

  const validateThenUpdate = (e) => {
    const checkboxes = document.getElementsByName(e.target.name);
    const checked = [];
    checkboxes.forEach(box => box.checked ? checked.push(box.value) : null);
    valueChanged(questionKey, checked, !!checked.length);
  };

  const checkboxOptions = BuildCheckboxOptions(answers, rowKey, questionKey, validateThenUpdate, answer);

  const displayError = value => {
    let message = false;
    if(!value || !value.length){
      message = <FormattedMessage {...MessageDefinitions.validationRequired} />;
    }
    return message ? <div className="invalid-feedback">{message}</div> : null;
  };

  return <div className="builderOption-answer checkbox-section">
    {checkboxOptions}
    {displayError(answer)}
  </div>;
};

CheckboxQuestion.propTypes = {
  questionKey: React.PropTypes.string.isRequired,
  answers: React.PropTypes.array,
  valueChanged: React.PropTypes.func,
  label: React.PropTypes.string,
  answer: React.PropTypes.array
};

export default CheckboxQuestion;



/** WEBPACK FOOTER **
 ** ./src/main/js/questionGroupBuilder/components/questionTypes/CheckboxQuestion.js
 **/